import type { SystemFeatureCode } from "../subscription/models";
import { SYSTEM_FEATURE_CODES } from "../subscription/data/features.seed";

/** Features activées par module produit (slug PEP / Suite). */
export const MODULE_FEATURE_MAP: Record<string, SystemFeatureCode[]> = {
  rh: [
    "hr",
    "organization",
    "leave",
    "attendance",
    "schedule",
    "performance",
    "compensation",
    "training",
    "career",
    "payroll",
    "recruitment",
  ],
  workforce: ["hr", "organization", "identity"],
  recruitment: ["recruitment", "identity"],
  attendance: ["attendance", "identity"],
  erp: ["billing", "reports", "analytics", "identity"],
  procurement: ["billing", "reports"],
  inventory: ["inventory", "product_catalog"],
  product: ["product_catalog"],
  autoid: ["assets"],
  crm: ["crm", "tickets"],
  tickets: ["tickets", "itsm", "knowledge"],
  itsm: ["itsm", "problems", "changes", "knowledge"],
  billing: ["billing"],
  edu: ["edu", "identity", "attendance"],
  hospitol: ["hospitol"],
  mineportal: ["mineportal"],
  subportal: ["subportal"],
  comex: ["reports", "analytics"],
  finance: ["billing", "reports", "analytics"],
  legal: ["reports"],
  security: ["security"],
  notifications: ["identity"],
};

const BASE_TRIAL_FEATURES: SystemFeatureCode[] = ["identity", "reports"];

const FEATURE_CODE_SET = new Set<string>(SYSTEM_FEATURE_CODES);

export function parseModuleSlugs(
  raw: string | string[] | null | undefined
): string[] {
  if (!raw) return [];
  const list = Array.isArray(raw) ? raw : raw.split(",");
  return [
    ...new Set(
      list
        .map((slug) => slug.trim().toLowerCase())
        .filter(Boolean)
    ),
  ];
}

export function resolveFeaturesForModules(
  modules: string[]
): SystemFeatureCode[] {
  const features = new Set<SystemFeatureCode>(BASE_TRIAL_FEATURES);

  if (modules.length === 0) {
    for (const code of MODULE_FEATURE_MAP.rh ?? []) {
      features.add(code);
    }
    features.add("crm");
    features.add("tickets");
    return [...features];
  }

  for (const moduleSlug of modules) {
    const mapped = MODULE_FEATURE_MAP[moduleSlug];
    if (mapped) {
      for (const code of mapped) features.add(code);
    } else if (FEATURE_CODE_SET.has(moduleSlug)) {
      features.add(moduleSlug as SystemFeatureCode);
    }
  }

  return [...features];
}

export function mergeModuleFeatures(
  existing: SystemFeatureCode[],
  modules: string[]
): SystemFeatureCode[] {
  const merged = new Set<SystemFeatureCode>(existing);
  for (const code of resolveFeaturesForModules(modules)) {
    merged.add(code);
  }
  return [...merged];
}

export function formatModuleLabels(modules: string[]): string {
  if (modules.length === 0) return "ITaaS RH (essai)";
  return modules
    .map((slug) => slug.toUpperCase().replace(/-/g, " "))
    .join(", ");
}
